/* Cuurve: play a product's video on hover in product cards (collection pages, homepage).
   Only runs on desktop devices with a mouse. Uses the product's second media item when it is a video. */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (min-width: 990px)').matches) return;

  var cache = {};

  function getVideo(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p || !p.media || !p.media[1] || p.media[1].media_type !== 'video') return null;
          var mp4s = (p.media[1].sources || []).filter(function (s) {
            return s.format === 'mp4' || s.mime_type === 'video/mp4';
          });
          if (!mp4s.length) return null;
          mp4s.sort(function (a, b) { return (a.height || 0) - (b.height || 0); });
          var pick = mp4s.filter(function (s) { return (s.height || 0) >= 480; })[0] || mp4s[mp4s.length - 1];
          var poster = p.media[1].preview_image && p.media[1].preview_image.src;
          return { url: pick.url, poster: poster };
        })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  function handleFrom(wrapper) {
    var a = wrapper.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function enter(wrapper) {
    var media = wrapper.querySelector('.card__media .media');
    var handle = handleFrom(wrapper);
    if (!media || !handle) return;
    wrapper.__cuurveHover = true;
    getVideo(handle).then(function (info) {
      if (!info || !wrapper.__cuurveHover) return;
      var v = media.querySelector('video.cuurve-hover-video');
      if (!v) {
        v = document.createElement('video');
        v.className = 'cuurve-hover-video';
        v.muted = true;
        v.loop = true;
        v.playsInline = true;
        v.setAttribute('muted', '');
        v.setAttribute('playsinline', '');
        v.setAttribute('aria-hidden', 'true');
        v.preload = 'auto';
        if (info.poster) v.poster = info.poster;
        v.src = info.url;
        v.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;opacity:0;transition:opacity .3s ease;z-index:1;pointer-events:none;';
        media.appendChild(v);
      }
      v.style.opacity = '1';
      var played = v.play();
      if (played && played.catch) played.catch(function () {});
    });
  }

  function leave(wrapper) {
    wrapper.__cuurveHover = false;
    var v = wrapper.querySelector('video.cuurve-hover-video');
    if (v) {
      v.style.opacity = '0';
      v.pause();
      try { v.currentTime = 0; } catch (e) {}
    }
  }

  document.addEventListener('mouseover', function (e) {
    var w = e.target.closest && e.target.closest('.card-wrapper');
    if (!w || (e.relatedTarget && w.contains(e.relatedTarget))) return;
    enter(w);
  });

  document.addEventListener('mouseout', function (e) {
    var w = e.target.closest && e.target.closest('.card-wrapper');
    if (!w || (e.relatedTarget && w.contains(e.relatedTarget))) return;
    leave(w);
  });
})();
